/**
 * @description: 短信费用明细报表
 * @author: lyr
*/
<template>
    <div class="or-dxfm-report">
        <div class="list">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable clearable placeholder="请选择门店" @change="changeShop($event)">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="短信类型">
                    <el-select v-model="list_form.type" filterable clearable placeholder="请选择短信类型">
                        <el-option v-for="item in sms_type" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="接收号码">
                    <el-input placeholder="请输入手机号" clearable v-model="list_form.mobile"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <div class="total">费用总额：{{total_amount}}</div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column prop="create_time" label="时间"></el-table-column>
                <el-table-column prop="type_name" label="短信类型"></el-table-column>
                <el-table-column prop="content" label="短信内容"></el-table-column>
                <el-table-column prop="mobile" label="接收号码"></el-table-column>
                <el-table-column prop="amount" label="费用"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'or-dxfm-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                sms_type: [], // 短信类型列表
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    type: '',
                    mobile: '', 
				},
				list_table: [],
				list_page: 1,
                list_total: 0,
                total_amount: 0,
            }
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.setShopDefaultTime(this.list_form.shop_id)
                this.getSmsTypeList()
                this.getList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取短信类型
            getSmsTypeList: function(shop_id) {
                const _this = this;

                Vue.axios.post('Report/getSmsTypeList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.sms_type = res.data.response.result;
                        _this.sms_type.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Report/getSmsSendLog', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.list_form.start_time,
                            "end_time": _this.list_form.end_time,
							"shop_id": _this.list_form.shop_id,
                            "type": _this.list_form.type,
                            "mobile": _this.list_form.mobile
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.count)
                            _this.total_amount = res.data.response.result.total_amount
						}
						_this.list_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            changeShop(val) {
                this.list_form.shop_id = val
                if (!!val) {
                    this.setShopDefaultTime(this.list_form.shop_id)
                }
            },

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },
            
            listExport: function() {
                window.location.href = Vue.ctUrl + "Report/exportSmsSendLog" +
                    "?start_time=" + this.list_form.start_time +
                    "&end_time=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&type=" + this.list_form.type +
                    "&mobile="+ this.list_form.mobile;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    
    
</style>